<template>
  <!--用户统计信息显示，注册用户数，下载量，上传量,g工作时间  -->
  <h1 class="mt-4">{{$t("reportmessage.title")}}</h1>

  <el-row justify="center" class="mt-5">
    <el-col :span="4">
      <el-card class="box-card">
        <div><h4 style="color: green">{{$t("reportmessage.RUsers")}}</h4></div>
        <div class="registeredblock">
          <el-image
            :src="require('../../assets/registered-users.svg')"
            
          />
        </div>
        <div><h3>{{usercount}}</h3></div>
      </el-card>
    </el-col>

    <el-col :span="4" :offset="2">
      <el-card class="box-card">
        <div><h4 style="color: orange">{{$t("reportmessage.download")}}
</h4></div>
        <div class="registeredblock">
          <el-image
            :src="require('../../assets/downloaded-products.svg')"
            
          />
        </div>
        <div><h3>{{downloadvolum}} GB</h3></div>
      </el-card>
    </el-col>


    <el-col :span="4" :offset="2">
      <el-card class="box-card">
        <div><h4 style="color: green">{{$t("reportmessage.Productsnum")}}
</h4></div>
        <div class="registeredblock">
          <el-image
            :src="require('../../assets/published-products.svg')"
            
          />
        </div>
        <div><h3>{{datacount}}</h3></div>
      </el-card>
    </el-col>


    <el-col :span="4" :offset="2">
      <el-card class="box-card">
        <div><h4 style="color: green">{{$t("reportmessage.Availability")}}</h4></div>
        <div class="registeredblock">
          <el-image
            :src="require('../../assets/availability.svg')"
            
          />
        </div>
        <div><h3>100%</h3></div>
      </el-card>
    </el-col>

  </el-row>
</template>

<script>

import {getoverallinfo} from '../../js/querydata'
import { useI18n } from "vue-i18n";
import {
  toRefs,
  reactive,
  onMounted
} from "vue";

export default {
    setup() {
      const state = reactive({
      usercount:0,
      downloadvolum:100,
      datacount:10
    }); 
    const {t} = useI18n();
    onMounted(() => {
      console.log(t)
      getoverallinfo().then((res)=> {
        if (res.status === 200) {
          state.datacount=res.data.datacount
          state.downloadvolum=res.data.downloadvolum
          state.usercount=res.data.usercount
        }
      })
    
    });

    return(toRefs(state))
    },
}
</script>

<style scoped>
.registeredblock {
  padding-top: 10px;
  text-align: center;
  border-right: solid 1px var(--el-border-color);
  display: inline-block;
  box-sizing: border-box;
  width: 110px;
  vertical-align: top;
}
h4{
    font-size: medium;
}
</style>